<script lang="ts" setup>
import LayoutSider from './Sider/index.vue'
import LayoutHeader from './Header/index.vue'
import LayoutContent from './Content/index.vue'
import AiAssistant from '@/components/AiAssistant/index.vue'
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import useMenu from '@/hooks/useMenu'
import { setIsNewbieGuideFinished } from '@/utils/guide'
import { getMenuGuideRemind } from '@/utils/guide/menuGuide'
import { GuideRemindFun } from '@/views/components/GuideRemind/js/type'
import {
  PAGE_OR_MODULE_VALUE,
  getPageVisitCount,
  addPageVisitCount,
  getIsNewbieFinish
} from '@/utils/pageVisit'

const collapsed = ref(false)

const route = useRoute()
const metaConfig = computed(() => route.meta ?? {})

const menuStore = useMenu()

watch(menuStore.isRouteInited, (bool) => {
  // 路由初始化完成（比isMenuInited更后）
  if (bool) {
    safelyHandleMenuGuideRemind()
  }
})

// #region 菜单的新手指引
const guideRemindFun = inject('guideRemindFun') as GuideRemindFun
/** 展示菜单的指引 */
const handleMenuGuideRemind = async () => {
  await nextTick()
  /** 获取访问次数 */
  const getVisitCount = await getPageVisitCount(PAGE_OR_MODULE_VALUE.SIDE_MENU)
  /** 是否使用新的新手指引 */
  const useNewbieGuide = !(await getIsNewbieFinish())
  /** 是否是首次访问 */
  const useFirstVisit = getVisitCount === 0
  // 首次登录默认打开
  if (useFirstVisit || useNewbieGuide) {
    const usePaycenterGuide = useNewbieGuide && menuStore.checkPathAvailable('/leyo-pay-center/')
    const useIndexGuide = useNewbieGuide && menuStore.checkPathAvailable('/index')
    const isIndexPage = route.name === 'IndexPageMain'
    const menuGuideRemindConfig = getMenuGuideRemind({
      useFirstVisit,
      useNewbieGuide,
      usePaycenterGuide,
      isIndexPage,
      useIndexGuide
    })
    // 没有配置代表没有菜单需要指引
    if (!menuGuideRemindConfig) {
      setIsNewbieGuideFinished(true)
      return
    }
    if (useFirstVisit) {
      // 增加访问次数
      addPageVisitCount(PAGE_OR_MODULE_VALUE.SIDE_MENU)
    }
    // 开启指引
    guideRemindFun(menuGuideRemindConfig)
  } else {
    setIsNewbieGuideFinished(true)
  }
}
/** 安全地设置新手指引是否完成 */
const safelyHandleMenuGuideRemind = async () => {
  try {
    await handleMenuGuideRemind()
  } catch (error) {
    setIsNewbieGuideFinished(true)
  }
}
// #endregion
</script>

<template>
  <ALayout :style="{ height: '100%', width: '100%' }">
    <LayoutSider v-model:collapsed="collapsed" :hidden="metaConfig.hideSider" />
    <ALayout>
      <LayoutHeader v-model:collapsed="collapsed" :hidden="metaConfig.hideSider" />
      <LayoutContent :hide-header="metaConfig.hidePageHeader || false" />
    </ALayout>
    <AiAssistant />
  </ALayout>
</template>
